var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Main-Content",attrs:{"id":"AccountSharedRulesetsEdit"}},[_c('Page',{attrs:{"title":_vm.$t('AccountSharedRulesets.Edit Ruleset'),"primaryAction":{
      label: _vm.$t('Save'),
      disabled: _vm.rulesetError || !_vm.hasChanged,
      onAction: function () { return _vm.updateRuleset(); }
    },"breadcrumbs":[
      {
        label: _vm.$t('Cancel'),
        onAction: function () { return _vm.stopEditRuleset(); }
      }
    ]}},[(_vm.loading)?_c('LoadingLayout'):_vm._e(),(!_vm.loading)?_c('Layout',[_c('LayoutSection',[_c('ruleset-editor',{attrs:{"locale":_vm.theUser.defaultLanguage,"mode":"shared","auth-key":_vm.authKey,"rulesets":_vm.inputRulesets,"history":[],"segment-url-fn":_vm.getSegmentUrl,"whitelisted-rule-types":_vm.whiteListedRuleTypes},on:{"update":function (val) { return _vm.state = val; },"error":_vm.handleError}})],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }